import React from 'react';
import PropTypes from 'prop-types';

const HomePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M3.39029 13.4381C3.1442 13.6274 3 13.9203 3 14.2308V15.7384C3 16.2907 3.44772 16.7384 4 16.7384H6V27.0099C6 27.5622 6.44772 28.0099 7 28.0099H13V19.0099C13 18.4576 13.4477 18.0099 14 18.0099H18C18.5523 18.0099 19 18.4576 19 19.0099V28.0099H25C25.5523 28.0099 26 27.5622 26 27.0099V16.7384H28C28.5523 16.7384 29 16.2907 29 15.7384V14.2308C29 13.9203 28.8558 13.6274 28.6097 13.4381L16.6097 4.20738C16.2503 3.93087 15.7497 3.93087 15.3903 4.20738L3.39029 13.4381Z"
    />
  );
};

HomePath.propTypes = {
  fill: PropTypes.string,
};

export default HomePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/home.jsx